module.exports = __webpack_public_path__ + "img/logo.866d5775.jpeg";